module.exports = __webpack_public_path__ + "media/images/spree/frontend/content/error/clothing-b207aae5614daec4e1554ef8e0610e37.jpg";